import { KybStatus } from '@Common/types/bo/b2b/companies';

import { makeChoices } from '@Utils/makeChoices';

export const kybStatusChoices = makeChoices<KybStatus>({
  created: 'resources.companies.choices.created',
  in_review: 'resources.companies.choices.in_review',
  verified: 'resources.companies.choices.verified',
  denied: 'resources.companies.choices.denied',
  resigned: 'resources.companies.choices.resigned',
});
